import { render, staticRenderFns } from "./RecordAppConfig.vue?vue&type=template&id=f6fc751c&scoped=true&"
import script from "./RecordAppConfig.vue?vue&type=script&lang=ts&"
export * from "./RecordAppConfig.vue?vue&type=script&lang=ts&"
import style0 from "./RecordAppConfig.vue?vue&type=style&index=0&id=f6fc751c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fc751c",
  null
  
)

export default component.exports